import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function ScheduleAPI(): BringozApi {
  return {
    base: `/schedule`,
    infiniteScroll: {
      address: `/schedule`,
      cmd: 'GET'
    },
    actions: {
      getManyAgents: {
        address: 'agent',
        cmd: 'GET',
        updateable: true
      },
      getManyByIds: {
        address: 'agent/byIds',
        cmd: 'GET',
        updateable: true
      },
      getByAgentId: {
        address: 'agent/{id}',
        cmd: 'GET',
        updateable: true
      },
      getByBranchId: {
        address: 'branch/{id}',
        cmd: 'GET',
        updateable: true
      },
      updateOneByBranchId: {
        address: 'branch/{id}/{scheduleId}',
        cmd: 'POST',
        updateable: true
      },
      createManyByBranchId: {
        address: 'branch/{id}',
        cmd: 'PUT',
        updateable: true
      },
      deleteOneByBranchId: {
        address: 'branch/{id}/{scheduleId}',
        cmd: 'DELETE',
        updateable: true
      },
      getAgentScheduleInstances: {
        address: 'agent/all',
        cmd: 'GET',
        updateable: false
      },
      createManyByAgentId: {
        address: 'agent/{id}',
        cmd: 'PUT',
        updateable: true
      },
      createLeaveByAgentId: {
        address: 'agent/leave/{id}',
        cmd: 'PUT',
        updateable: true
      },
      validateManyByAgentId: {
        address: 'agent/{id}/validate',
        cmd: 'POST',
        updateable: false
      },
      getManyUnified: {
        address: 'agent/unified',
        cmd: 'GET',
        updateable: true
      },
      autoCreate: {
        address: 'agent/autoCreate',
        cmd: 'POST',
        updateable: true
      },
      getOneByAgentId: {
        address: 'agent/{agentId}/{scheduleId}',
        cmd: 'GET',
        updateable: true
      },
      updateOneByAgentId: {
        address: 'agent/{agentId}/{scheduleId}',
        cmd: 'POST',
        updateable: true
      },
      updateScheduleExtraData: {
        address: 'agent/extraData',
        cmd: 'POST',
        updateable: true
      },
      deleteOneByAgentId: {
        address: 'agent/{id}/{scheduleId}',
        cmd: 'DELETE',
        updateable: true
      },
      getManyDepot: {
        address: 'depot',
        cmd: 'GET',
        updateable: true
      },
      getByDepotId: {
        address: 'depot/{id}',
        cmd: 'GET',
        updateable: true
      },
      createManyByDepotId: {
        address: 'depot/{id}',
        cmd: 'PUT',
        updateable: true
      },
      updateOneByDepotId: {
        address: 'depot/{id}/{scheduleId}',
        cmd: 'POST',
        updateable: true
      },
      deleteOneByDepotId: {
        address: 'depot/{id}/{scheduleId}',
        cmd: 'DELETE',
        updateable: true
      },
      getTemplateSchedule: {
        address: 'template/{id}',
        cmd: 'GET',
        updateable: true
      },
      createTemplateSchedule: {
        address: 'template/{id}',
        cmd: 'PUT',
        updateable: true
      },
      updateTemplateSchedule: {
        address: 'template/{id}/{scheduleId}',
        cmd: 'POST',
        updateable: true
      },
      deleteTemplateSchedule: {
        address: 'template/{id}/{scheduleId}',
        cmd: 'DELETE',
        updateable: true
      },
      getScheduleTimeline: {
        address: '{scheduleId}/timeline',
        cmd: 'GET',
        updateable: false
      },
      approveSchedule: {
        address: 'agent/approve',
        cmd: 'POST',
        updateable: true
      },
      rejectSchedule: {
        address: 'agent/reject',
        cmd: 'POST',
        updateable: true
      },
      exportAgentSchedules: {
        address: 'agent/actions/export',
        cmd: 'POST',
        updateable: false
      },
    }
  }
}

angular
  .module('bringoz.admin.schedule')
  .factory('ScheduleAPI', ScheduleAPI);
